import { Avatar, Box, Chip, Tooltip, tooltipClasses } from '@mui/material'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import { useState } from 'react'
import { common } from '@mui/material/colors'
import { colors, colorKeys } from 'Components/Enrollment/Colors'
export function EnrollmentChip (props: { statusId: number, rank?: number | null, showToolTip?: boolean }): JSX.Element {
  const color = '#4591bb'

  const [showTooltip, setShowTooltip] = useState(false)
  const onShowTT = (): void => {
    setShowTooltip(true)
  }
  const onHideTT = (): void => {
    setShowTooltip(false)
  }

  const keyString = colorKeys[props.statusId]
  const selectedColor = colors[keyString] ?? colors.pending
  const toolTip =
    <Tooltip
      title={selectedColor.toolTip}
      placement='top'
      onClose={onHideTT}
      open={showTooltip}
      arrow
      PopperProps={{
        sx: {
          [`& .${tooltipClasses.arrow}`]: {
            color
          },
          [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: color
          }
        }
      }}
    >
      <div>
        <Avatar data-testid="toolTipButton" onClick={onShowTT}
          sx={{ bgcolor: common.black, width: '18px', height: '18px', fontSize: '15px', cursor: 'pointer' }}
        >i</Avatar>
      </div>
    </Tooltip>

  return <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
    <Chip
      sx={{
        fontSize: '18px',
        height: '24px',
        p: '14px 6px',
        color: selectedColor.textColor,
        backgroundColor: selectedColor.fill,
        fontWeight: '600'
      }}
      data-testid='chipComponent'
      icon={<FiberManualRecordIcon sx={{ color: selectedColor.textColor + ' !important', height: '12px', width: '12px' }} />} label={selectedColor.text}
    />
    {keyString === 'pending' && props.rank != null && (<Avatar sx={{ height: '25px', width: '25px' }} data-testid="rank">{props.rank}</Avatar>)}
    {(props.showToolTip ?? false) && toolTip}
  </Box>
}
